export default {"src":"/_next/static/media/calendar-light.284446e9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};